import {
  OVERTIME_36HOURS_DETAIL_FETCHING,
  OVERTIME_36HOURS_DETAIL_FAILED,
  OVERTIME_36HOURS_DETAIL_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case OVERTIME_36HOURS_DETAIL_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case OVERTIME_36HOURS_DETAIL_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case OVERTIME_36HOURS_DETAIL_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
};
